import Vue from 'vue'
import VueRouter from 'vue-router'
import Authentication from '../views/Authentication.vue'
import TabPanel from '../components/tabs/TabPanel.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/searchPaper',
    name: 'searchPaper',
    component: TabPanel,
    meta:{
      requiresAuth:true
    }
  }, {
    path: '/',
    name: 'Authentication',
    component: Authentication
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next)=>{
  //page that require auth
  if(to.matched.some(record => record.meta.requiresAuth)){
    if(store.state.authentication.isAuthenticated){
      next()
    }else{
      next('/')
    }
  //does not require auth
  }else{
    next()
  }
})

export default router
